/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tabtimeline1Inputs */

const en_tabtimeline1 = /** @type {(inputs: Tabtimeline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline`)
};

const pt_tabtimeline1 = /** @type {(inputs: Tabtimeline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia`)
};

/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Tabtimeline1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const tabtimeline1 = /** @type {((inputs?: Tabtimeline1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tabtimeline1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tabtimeline1(inputs)
	return pt_tabtimeline1(inputs)
});
export { tabtimeline1 as "tabTimeline" }